var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.00008C4.68613 2.00008 1.99984 4.68637 1.99984 8.00008C1.99984 11.3138 4.68613 14.0001 7.99984 14.0001C11.3135 14.0001 13.9998 11.3138 13.9998 8.00008C13.9998 4.68637 11.3135 2.00008 7.99984 2.00008ZM0.666504 8.00008C0.666504 3.94999 3.94975 0.666748 7.99984 0.666748C12.0499 0.666748 15.3332 3.94999 15.3332 8.00008C15.3332 12.0502 12.0499 15.3334 7.99984 15.3334C3.94975 15.3334 0.666504 12.0502 0.666504 8.00008Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 6.00008C6.89527 6.00008 5.99984 6.89551 5.99984 8.00008C5.99984 9.10465 6.89527 10.0001 7.99984 10.0001C9.10441 10.0001 9.99984 9.10465 9.99984 8.00008C9.99984 6.89551 9.10441 6.00008 7.99984 6.00008ZM4.6665 8.00008C4.6665 6.15913 6.15889 4.66675 7.99984 4.66675C9.84079 4.66675 11.3332 6.15913 11.3332 8.00008C11.3332 9.84103 9.84079 11.3334 7.99984 11.3334C6.15889 11.3334 4.6665 9.84103 4.6665 8.00008Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8151 2.81534C3.07545 2.55499 3.49756 2.55499 3.75791 2.81534L6.58457 5.64201C6.84492 5.90236 6.84492 6.32447 6.58457 6.58482C6.32423 6.84517 5.90212 6.84517 5.64177 6.58482L2.8151 3.75815C2.55475 3.4978 2.55475 3.07569 2.8151 2.81534Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4151 9.41534C9.67545 9.15499 10.0976 9.15499 10.3579 9.41534L13.1846 12.242C13.4449 12.5024 13.4449 12.9245 13.1846 13.1848C12.9242 13.4452 12.5021 13.4452 12.2418 13.1848L9.4151 10.3582C9.15475 10.0978 9.15475 9.67569 9.4151 9.41534Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1846 2.81534C13.4449 3.07569 13.4449 3.4978 13.1846 3.75815L10.3579 6.58482C10.0976 6.84517 9.67545 6.84517 9.4151 6.58482C9.15475 6.32447 9.15475 5.90236 9.4151 5.64201L12.2418 2.81534C12.5021 2.55499 12.9242 2.55499 13.1846 2.81534Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7112 3.28868C12.9716 3.54903 12.9716 3.97114 12.7112 4.23149L10.3579 6.58482C10.0976 6.84517 9.67545 6.84517 9.4151 6.58482C9.15475 6.32447 9.15475 5.90236 9.4151 5.64201L11.7684 3.28868C12.0288 3.02833 12.4509 3.02833 12.7112 3.28868Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58457 9.41534C6.84492 9.67569 6.84492 10.0978 6.58457 10.3582L3.75791 13.1848C3.49756 13.4452 3.07545 13.4452 2.8151 13.1848C2.55475 12.9245 2.55475 12.5024 2.8151 12.242L5.64177 9.41534C5.90212 9.15499 6.32423 9.15499 6.58457 9.41534Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.02e228385f3f7debc48a488253584c5e.svg";
export { ForwardRef as ReactComponent };